export default __webpack_public_path__ + "static/media/img1.eff8227a.webp";